import PingPongCapability from './pingPong';
import CallFrameAppletCapability from './applets/callFrameApplet';
import ModalAppletCapability from './applets/modalApplet';
import ConfigAppletCapability from './applets/configApplet';
import HeadlessAppletCapability from './applets/headlessApplet';
import PageAppletCapability from './applets/pageApplet';
import OverlayAppletCapability from './applets/overlayApplet';
import PostCallAppletCapability from './applets/postCallApplet';
import DashboardAppletCapability from './applets/dashboardApplet';
import ReceiveContextCapability from './receiveContext';
import AppsDockControlCapability from './controls/appsDockControl';
import SidebarMenuControlCapability from './controls/sidebarMenuControl';
import MultiplayerCallCapability from './multiplayer/call';
import MultiplayerRoomCapability from './multiplayer/room';
import StorageCapability from './storage';
import FileTransferCapability, { type StartHandler } from './fileTransfer';
import FileServiceCapability, {
  type RequestUploadLinksHandler,
  type GetFileMetadataHandler,
  type DeleteFilesHandler,
  type GetServiceUrlHandler,
} from './fileService';
import BackendCapability from './backend';
import NotificationCapability from './notification';
import AppTokenCapability, { type OnGetHandler } from './appToken';
import PhotoCaptureCapability from './photoCapture';
import PostInstallCapability from './postInstall';
import TranscriptionCapability from './transcription';
import AlertBannerCapability from './alertBanner';
import AppEventsCapability from './appEvents';
import PlaySoundCapability from './playSound';
import NavigationInterceptionCapability from './navigationInterception';
import FeatureFlagCapability from './featureFlag';

export type { CommandHandler } from './multiplayer/multiplayer';
export type {
  StartHandler,
  OnGetHandler,
  RequestUploadLinksHandler,
  GetFileMetadataHandler,
  DeleteFilesHandler,
  GetServiceUrlHandler,
};

export default {
  [PingPongCapability.id]: PingPongCapability,
  [CallFrameAppletCapability.id]: CallFrameAppletCapability,
  [ModalAppletCapability.id]: ModalAppletCapability,
  [ConfigAppletCapability.id]: ConfigAppletCapability,
  [HeadlessAppletCapability.id]: HeadlessAppletCapability,
  [PageAppletCapability.id]: PageAppletCapability,
  [OverlayAppletCapability.id]: OverlayAppletCapability,
  [PostCallAppletCapability.id]: PostCallAppletCapability,
  [DashboardAppletCapability.id]: DashboardAppletCapability,
  [ReceiveContextCapability.id]: ReceiveContextCapability,
  [AppsDockControlCapability.id]: AppsDockControlCapability,
  [SidebarMenuControlCapability.id]: SidebarMenuControlCapability,
  [MultiplayerCallCapability.id]: MultiplayerCallCapability,
  [MultiplayerRoomCapability.id]: MultiplayerRoomCapability,
  [StorageCapability.id]: StorageCapability,
  [FileTransferCapability.id]: FileTransferCapability,
  [FileServiceCapability.id]: FileServiceCapability,
  [BackendCapability.id]: BackendCapability,
  [NotificationCapability.id]: NotificationCapability,
  [AppTokenCapability.id]: AppTokenCapability,
  [PhotoCaptureCapability.id]: PhotoCaptureCapability,
  [PostInstallCapability.id]: PostInstallCapability,
  [TranscriptionCapability.id]: TranscriptionCapability,
  [AlertBannerCapability.id]: AlertBannerCapability,
  [AppEventsCapability.id]: AppEventsCapability,
  [PlaySoundCapability.id]: PlaySoundCapability,
  [NavigationInterceptionCapability.id]: NavigationInterceptionCapability,
  [FeatureFlagCapability.id]: FeatureFlagCapability,
};

export {
  PingPongCapability,
  CallFrameAppletCapability,
  ModalAppletCapability,
  ConfigAppletCapability,
  HeadlessAppletCapability,
  PageAppletCapability,
  OverlayAppletCapability,
  PostCallAppletCapability,
  DashboardAppletCapability,
  ReceiveContextCapability,
  AppsDockControlCapability,
  SidebarMenuControlCapability,
  MultiplayerCallCapability,
  MultiplayerRoomCapability,
  StorageCapability,
  FileTransferCapability,
  FileServiceCapability,
  BackendCapability,
  NotificationCapability,
  AppTokenCapability,
  PhotoCaptureCapability,
  PostInstallCapability,
  TranscriptionCapability,
  AlertBannerCapability,
  AppEventsCapability,
  PlaySoundCapability,
  NavigationInterceptionCapability,
  FeatureFlagCapability,
};
